import { currencyArr } from './constants.js';

export function formatNumber(value) {
  return Number(value).toLocaleString();
}

export function moneyFormatOption() {
  const currentCurrency = currencyArr.find((el) => el.iso === theme.initCurrency);

  const options = {};

  options.fractionDigits =
    Shopify.currency.rate > currentCurrency.limitRate ? { maximumFractionDigits: 0 } : { minimumFractionDigits: 2 };
  options.toFixedValue = Shopify.currency.rate > currentCurrency.limitRate ? 0 : 2;

  return options;
}

export function formatMoney(value) {
  let formattedMoney;

  if (Shopify.currency.rate !== '1.0') {
    const refactoredValue = Shopify.currency.rate !== '1.0' && value * Shopify.currency.rate;
    const options = moneyFormatOption();

    formattedMoney = `${Number(refactoredValue.toFixed(options.toFixedValue)).toLocaleString(
      'en-US',
      options.fractionDigits
    )}`;
  } else {
    formattedMoney = Number(value).toLocaleString();
  }

  return formattedMoney;
}

export function debounce(func, timeout = 300) {
  let timer;

  return (...args) => {
    clearTimeout(timer);
    timer = setTimeout(() => {
      func.apply(this, args);
    }, timeout);
  };
}

export function htmlDecode(input) {
  const doc = new DOMParser().parseFromString(input, 'text/html');

  return doc.documentElement.textContent;
}
